import React, {useEffect, useState} from 'react';

import './ProfileCompany.scss';
import {Col, Form, Image, Modal, Row} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {setPlanType} from "../../../store/slices/companySlice";
import {sendResumeToAI, setResumeAnalysing} from "../../../store/slices/candidateSlice";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, RootState} from "../../../store/store";
import {ASSETS_URL} from "../../../constants";
import icDone from "../../../assets/images/ic_done.svg";
import axios from 'axios';
import { config } from '../../../_config/config';
import { toast } from 'react-toastify';

const ProfilePlansCompany = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [showSmartModal, setShowSmartModal] = useState(false);
  const [showMonthlyModal, setShowMonthlyModal] = useState(false);
  const [showYearlyModal, setShowYearlyModal] = useState(false);
  const [showTrialExpiredModal, setShowTrialExpiredModal] = useState(false);
  const [promoCode, setPromoCode] = useState('');
  const handleCloseSmartModal = () => { setShowSmartModal(false); setPromoCode(''); };
  const handleShowSmartModal = () => setShowSmartModal(true);
  const handleCloseMonthlyModal = () => { setShowMonthlyModal(false); setPromoCode(''); };
  const handleShowMonthlyModal = () => setShowMonthlyModal(true);
  const handleCloseYearlyModal = () => { setShowYearlyModal(false); setPromoCode(''); };
  const handleShowYearlyModal = () => setShowYearlyModal(true);
  const companyDetails = useSelector(
    (state: RootState) => state.companyReducer
  );

  const defaultPlanBenefits: string[] = t('planPage.default.benefits', {
    returnObjects: true,
  });
  const monthlyPlanBenefits: string[] = t('planPage.default.monthlybenefits', {
    returnObjects: true,
  });
  const smartPlanBenefits: string[] = t('planPage.smart.benefits', {
    returnObjects: true,
  });
  const currentPlan = companyDetails.plan as {
    plan_name?: string;
    name?: string;
  } | null;
  const currentPlanName = (currentPlan?.plan_name || currentPlan?.name || '').toLowerCase();
  const isCurrentMonthlyPlan = currentPlanName.includes('monthly');
  const isCurrentYearlyPlan = currentPlanName.includes('yearly');
  const isCurrentSmartPlan = currentPlanName.includes('smart');

  const handleSubmit = async (planType: string) => {
    const trimmedCode = promoCode.trim().toUpperCase();
    if (trimmedCode) {
      try {
        await axios.get(`${config.SERVER_URL}promo-codes/validate/`, { params: { code: trimmedCode } });
      } catch {
        toast.error(t('errors.promoCodeInvalid'));
        return;
      }
    }
    setShowYearlyModal(false);
    setShowMonthlyModal(false);
    setShowSmartModal(false);
    setPromoCode('');
    const response = await dispatch(setPlanType({ plantype: planType, promoCode: trimmedCode || undefined }));
    const jsonString = JSON.stringify(response.payload);
    const base64String = btoa(jsonString);
    window.open(window.location.protocol + '//' + window.location.hostname + '/prepayment/' + base64String, '_blank');
  };

  function closeSmartModal(): void {
    setShowSmartModal(false);
  }

  useEffect(() => {
    if (companyDetails.trialPeriodEnded) {
      setShowTrialExpiredModal(true);
    }
  }, [companyDetails.trialPeriodEnded])

  function closeTrialExpiredModal(): void {
    setShowTrialExpiredModal(false);
  }

  return (
    <div className='zestur-card'>
      <h2 className='general-heading mt-4 mb-4'>{t('planPage.title')}</h2>
      <p className='general-sub-heading'>
        {companyDetails.trialPeriodEnded &&
          t('plans.trialExpiredHeading') + " " + t('plans.trialExpiredBody')
        }
        {!companyDetails.trialPeriodEnded &&
          t('planPage.description')
        }
      </p>
      <Row className='mt-4 tablet-gap-1'>
        <Col xs={12} lg={4}>
          <div className='plans-container'>
            <div className='plans-container-header'>
              <div className='plans-container-header__title'>
                {t('planPage.default.title')}
              </div>
              <div className='plans-container-header__rate'>
                {t('planPage.default.monthlyprice')}
                <span className='plans-container-header__subrate'>
                  {t('planPage.default.yearlyprice')}
                </span>
              </div>
            </div>
            <div className='plans-container-content mt-4'>
              <ul>
                {monthlyPlanBenefits.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
            <div className='d-flex flex-column align-items-center justify-content-center mt-5 mb-3'>
              <button
                className='btn btn-primary primary-btn-color w-100'
                onClick={handleShowMonthlyModal}
              >
                {t('planPage.default.button')}
              </button>
              {isCurrentMonthlyPlan && (
                <div className='plan-current-badge'>
                  <span>{t('planPage.currentPlanLabel')}</span>
                </div>
              )}
            </div>
          </div>
        </Col>
        <Col xs={12} lg={4}>
          <div className='plans-container'>
            <div className='plans-container-header'>
              <div className='plans-container-header__title'>
                {t('planPage.default.title')}
              </div>
              <div className='plans-container-header__rate'>576€&nbsp;{t('planPage.annual')}</div>
            </div>
            <div className='plans-container-content mt-4'>
              <ul>
                {defaultPlanBenefits.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
            <div className='d-flex flex-column align-items-center justify-content-center mt-5 mb-3'>
              <button
                className='btn btn-primary primary-btn-color w-100'
                onClick={handleShowYearlyModal}
              >
                {t('planPage.default.button')}
              </button>
              {isCurrentYearlyPlan && (
                <div className='plan-current-badge'>
                  <span>{t('planPage.currentPlanLabel')}</span>
                </div>
              )}
            </div>
          </div>
        </Col>
        <Col xs={12} lg={4}>
          <div className='plans-container bg'>
            <div className='plans-container-header'>
              <div className='plans-container-header__title'>
                {t('planPage.smart.title')}
              </div>
              <div className='plans-container-header__rate'>
                3000€&nbsp;{t('planPage.annual')}
              </div>
            </div>
            <div className='plans-container-content mt-4'>
              <ul>
                {smartPlanBenefits.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
            <div className='d-flex flex-column align-items-center justify-content-center mt-5 mb-3'>
              <button
                className='btn btn-primary bg-white text-primary w-100'
                onClick={handleShowSmartModal}
              >
                {t('planPage.default.button')}
              </button>
              {isCurrentSmartPlan && (
                <div className='plan-current-badge'>
                  <span>{t('planPage.currentPlanLabel')}</span>
                </div>
              )}
            </div>
          </div>
        </Col>
      </Row>
      <p className='general-sub-heading mt-4 mb-4'>{t('planPage.postWord')}</p>
      <Modal show={showSmartModal} centered onHide={handleCloseSmartModal}>
        <Modal.Body className='text-center py-5'>
          <h1 className='fw-bold my-4'>{t('planPage.paymentheading')}</h1>
          <p className='f-12 mt-4'>{t('planPage.paymentbody')}</p>
          <Form.Label className='text-muted f-12 mt-3'>{t('planDetails.formInfo.promoCodeLabel')}</Form.Label>
          <Form.Control
            type='text'
            className='mx-auto'
            style={{ maxWidth: '280px' }}
            placeholder={t('planDetails.formInfo.discountPlaceholder')}
            value={promoCode}
            onChange={(e) => setPromoCode(e.target.value)}
          />
          <button
            className='btn mt-4 mb-5 btn-primary primary-btn-color px-5 py-3'
            onClick={() => handleSubmit('smart')}
          >
            {t('planDetails.modal.acceptButton')}
          </button>
        </Modal.Body>
      </Modal>
      <Modal show={showMonthlyModal} centered onHide={handleCloseMonthlyModal}>
        <Modal.Body className='text-center py-5'>
          <h1 className='fw-bold my-4'>{t('planPage.paymentheading')}</h1>
          <p className='f-12 mt-4'>{t('planPage.paymentbody')}</p>
          <Form.Label className='text-muted f-12 mt-3'>{t('planDetails.formInfo.promoCodeLabel')}</Form.Label>
          <Form.Control
            type='text'
            className='mx-auto'
            style={{ maxWidth: '280px' }}
            placeholder={t('planDetails.formInfo.discountPlaceholder')}
            value={promoCode}
            onChange={(e) => setPromoCode(e.target.value)}
          />
          <button
            className='btn mt-4 mb-5 btn-primary primary-btn-color px-5 py-3'
            onClick={() => handleSubmit('monthly')}
          >
            {t('planDetails.modal.acceptButton')}
          </button>
        </Modal.Body>
      </Modal>
      <Modal show={showYearlyModal} centered onHide={handleCloseYearlyModal}>
        <Modal.Body className='text-center py-5'>
          <h1 className='fw-bold my-4'>{t('planPage.paymentheading')}</h1>
          <p className='f-12 mt-4'>{t('planPage.paymentbody')}</p>
          <Form.Label className='text-muted f-12 mt-3'>{t('planDetails.formInfo.promoCodeLabel')}</Form.Label>
          <Form.Control
            type='text'
            className='mx-auto'
            style={{ maxWidth: '280px' }}
            placeholder={t('planDetails.formInfo.discountPlaceholder')}
            value={promoCode}
            onChange={(e) => setPromoCode(e.target.value)}
          />
          <button
            className='btn mt-4 mb-5 btn-primary primary-btn-color px-5 py-3'
            onClick={() => handleSubmit('yearly')}
          >
            {t('planDetails.modal.acceptButton')}
          </button>
        </Modal.Body>
      </Modal>
      <Modal show={showTrialExpiredModal} centered onHide={closeTrialExpiredModal}>
        <Modal.Body className='text-center py-5'>
          <h2 className='fw-bold my-4'>{t('plans.trialExpiredHeading')}</h2>
          <p className='f-16 mt-4'>{t('plans.trialExpiredBody')}</p>
          <button
            className='btn mt-4 mb-5 btn-primary primary-btn-color px-5 py-3'
            onClick={() => closeTrialExpiredModal()}
          >
            {t('planDetails.modal.acceptButton')}
          </button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ProfilePlansCompany;
